import styled from "@emotion/styled";

export const LoadingStyled = styled.div`
  @keyframes ldio-w25ajxc6pq {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .ldio-w25ajxc6pq div {
    box-sizing: border-box !important;
  }
  .ldio-w25ajxc6pq > div {
    position: absolute;
    width: 144px;
    height: 144px;
    top: 28px;
    left: 28px;
    border-radius: 50%;
    border: 16px solid #000;
    border-color: #5BC500 transparent #5BC500 transparent;
    animation: ldio-w25ajxc6pq 1s linear infinite;
  }
  .ldio-w25ajxc6pq > div:nth-child(2) {
    border-color: transparent;
  }
  .ldio-w25ajxc6pq > div:nth-child(2) div {
    position: absolute;
    width: 100%;
    height: 100%;
    transform: rotate(45deg);
  }
  .ldio-w25ajxc6pq > div:nth-child(2) div:before,
  .ldio-w25ajxc6pq > div:nth-child(2) div:after {
    content: "";
    display: block;
    position: absolute;
    width: 16px;
    height: 16px;
    top: -16px;
    left: 48px;
    background: #5BC500;
    border-radius: 50%;
    box-shadow: 0 128px 0 0 #5BC500;
  }
  .ldio-w25ajxc6pq > div:nth-child(2) div:after {
    left: -16px;
    top: 48px;
    box-shadow: 128px 0 0 0 #5BC500;
  }
  .loadingio-spinner-dual-ring-0vpzkyvcrwt {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    background: none;
  }
  .ldio-w25ajxc6pq {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-w25ajxc6pq div {
    box-sizing: content-box;
  }
`;
